module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/ppa_presents.fr_CA-42f6e3f2450b839eaf54d062274ca9ff.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/ppa_presents.fr_CA.png
// module id = 2462
// module chunks = 2